import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexbox-grid';
import { translate } from 'react-i18next';
import { Search, MessageStatus } from './filters';
import { EmailLogsTable } from '.';
import Spin from 'antd/lib/spin';
import DatePicker from 'antd/lib/date-picker';
import moment from 'moment'

const { RangePicker } = DatePicker;

@translate()
export default class EmailLogsList extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    emailLogs: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    onTableChange: PropTypes.func.isRequired,
    onFilterSearchChange: PropTypes.func.isRequired,
    onFilterDateRangeChange: PropTypes.func.isRequired,
    onFilterStatusChange: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
  };
  constructor(props) {
    super(props);

    //oldest email logs are in July 2021
    const defaultFromDate = moment.utc("2021-07-01").format("YYYY-MM-DD") + "T00:00:00.000Z";
    this.state = {
      sentDateRange: {
        from: defaultFromDate,
        to: moment.utc().endOf('day').toISOString()
      }
    }
  }

  render() {
    const {
      emailLogs,
      pagination,
      filter,
      onTableChange,
      onFilterSearchChange,
      onFilterDateRangeChange,
      onFilterStatusChange,
      isLoading,
      t,
    } = this.props;
    return (

      <section>
        <h2>{t('E-mailové správy')}</h2>


        <Row center="xs" className="filters padded">
          {
            <Col xs={12} sm={4}>
              <MessageStatus
                key="messageStatus"
                value={filter.status}
                onChange={onFilterStatusChange}
              />
            </Col>
          /* <Col>
            <span>{t("Vyhľadávanie podľa priezviska alebo emailu adresáta:")}</span>
          </Col> */}
          <Col xs={12} sm={4}>
            <Search
              key="emailLogSearch"
              defaultValue={filter.search}
              onSearch={onFilterSearchChange}
            />
          </Col>
          {/* <Col>
            <span>{t("Dátum odoslania v rozsahu:")}</span>
          </Col> */}
          <Col xs={12} sm={4}>
            <RangePicker
              onChange={onFilterDateRangeChange}
              format="DD.MM.YYYY"
              style={Object.assign({ marginRight: 15 })}
              defaultValue={[moment.utc(this.state.sentDateRange.from), moment.utc(this.state.sentDateRange.to)]}
            />
          </Col>


        </Row>

        <EmailLogsTable
          emailLogs={emailLogs}
          pagination={pagination}
          onChange={onTableChange}
          loading={isLoading}
        />
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/messaging-dashboard/components/EmailLogsList.js